import { BaseRepositoryV2 } from "@/repositories/base-repository-v2";

export type DiscordReportPayload = {
  message: string;
  context?: unknown;
};

export type DiscordReportResponse = {
  ok: true;
};

const EMPTY_RESPONSE_BODY = "";

async function readResponseBody(response: Response): Promise<string> {
  try {
    return await response.text();
  } catch {
    return EMPTY_RESPONSE_BODY;
  }
}

export class DiscordRepository extends BaseRepositoryV2 {
  constructor() {
    super("");
  }

  sendReport = async (payload: DiscordReportPayload) => {
    const response = await fetch("/api/discord-webhook", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const responseBody = await readResponseBody(response);
      console.error("Discord webhook request failed", {
        status: response.status,
        body: responseBody,
      });
      throw new Error("DISCORD_REPORT_REQUEST_FAILED");
    }
    const data = (await response.json()) as DiscordReportResponse;
    return data;
  };
}

export const discordRepository = new DiscordRepository();
